<template>
  <StepperHeader :current="0" />
  <RegisterLayout>
    <template #description>
      <h2>¡Crea tu equipo de trabajo en minutos!</h2>
      <p>Ofrece una experiencia fluida y sin fisuras con comunicación omnicanal en la nube. 💪</p>

      <ul>
        <li><span>Accesibilidad desde cualquier lugar con conexión a internet.</span></li>
        <li>
          <span>
            Mejora de la eficiencia y productividad gracias a herramientas como enrutamiento
            inteligente de llamadas y reportes en tiempo real.
          </span>
        </li>
        <li>
          <span>
            Flexibilidad para ofrecer un servicio omnicanal, incluyendo chats y llamadas.</span
          >
        </li>
        <li>
          <span>
            Ahorro de costos al no tener que invertir en infraestructura y mantenimiento de
            servidores.
          </span>
        </li>
      </ul>
    </template>

    <template #form>
      <FormCard title="Crea tu cuenta 🤗" hide-img>
        <signup-form />
      </FormCard>
    </template>
  </RegisterLayout>
</template>

<script setup>
import SignupForm from "@/app/register/components/forms/SignupForm.vue";
import StepperHeader from "../header/StepperHeader.vue";
import RegisterLayout from "../layout/RegisterLayout.vue";
import FormCard from "@/app/auth/components/atoms/FormCard.vue";
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { customerPlanByToken } from "@/app/register/services";

const route = useRoute();
const router = useRouter();

const handleCustomerPlanByToken = async () => {
  try {
    const token = route.query.token;
    console.log(token, 'token');
    const response = await customerPlanByToken(token);
    console.log(response, 'validate token');
  } catch(error) {
    console.log(error.data, 'error');
    const data = error.data;
    router.push(`/token-register/expired?reference_name=${route.query.reference_name}&state=${data?.state}&date=${data?.validate_link_date}&hours=${data?.hours}`);
  }
};
onMounted(async () => {
  console.log('on mounted');
  await handleCustomerPlanByToken();
})
</script>

<style lang="sass" scoped>
.signup__wrapper
  display: grid
  grid-template-columns: repeat(2, 1fr)
  place-content: center

.container
  margin: 0 auto
  margin-top: 20px
  width: 70%
  min-width: 420px

.drawing
  margin-top: 170px
  text-align: center

.text--plan
  font-size: 20px
  font-weight: 400

.text--score
  font-size: 20px
  font-weight: 600

.container__info
  margin: 0 auto
  margin-top: 70px
  text-align: center
  margin-bottom: 18px

@media screen and (max-width: 920px)
  .container__info
    margin-bottom: 5px

.name
  font-weight: 600
  font-size: 30px
</style>
